'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = require('babel-runtime/helpers/get');

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _get6 = require('lodash/get');

var _get7 = _interopRequireDefault(_get6);

var _dec, _dec2, _dec3, _dec4, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _statistics = require('redux/modules/statistics');

var statisticsActions = _interopRequireWildcard(_statistics);

var _reduxConnect = require('redux-connect');

var _reactRouterRedux = require('react-router-redux');

var _components = require('components');

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _formComponents = require('components/formComponents');

var _forms = require('helpers/forms');

var _ProjectInfoFormValidation = require('./ProjectInfoFormValidation');

var _ProjectInfoFormValidation2 = _interopRequireDefault(_ProjectInfoFormValidation);

var _projects = require('selectors/projects');

var _Collapse = require('react-bootstrap/lib/Collapse');

var _Collapse2 = _interopRequireDefault(_Collapse);

var _datetime = require('helpers/datetime');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _auth = require('selectors/auth');

var _projects2 = require('helpers/projects');

var _asyncPromise = require('helpers/async-promise');

var _asyncPromise2 = _interopRequireDefault(_asyncPromise);

var _reactCookie = require('react-cookie');

var _storage = require('helpers/storage');

var _storage2 = _interopRequireDefault(_storage);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _FormRow = require('components/FormRow/FormRow');

var _FormRow2 = _interopRequireDefault(_FormRow);

var _AddSenderField = require('containers/Project/AddSenderField/AddSenderField');

var _AddSenderField2 = _interopRequireDefault(_AddSenderField);

var _strings = require('helpers/strings');

var _ProjectSenderInfo = require('containers/Project/ProjectSenderInfo/ProjectSenderInfo');

var _ProjectSenderInfo2 = _interopRequireDefault(_ProjectSenderInfo);

var _AddStatsViewerField = require('containers/Project/AddStatsViewerField/AddStatsViewerField');

var _AddStatsViewerField2 = _interopRequireDefault(_AddStatsViewerField);

var _ProjectStatsViewersList = require('containers/Project/ProjectStatsViewersList/ProjectStatsViewersList');

var _ProjectStatsViewersList2 = _interopRequireDefault(_ProjectStatsViewersList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./ProjectInfo.scss');

var formSelector = (0, _reduxForm.formValueSelector)('projectInfoForm');

var projectInfoFormDefaults = {
  bcove: '',
  storyboard: '',
  contentLink: '',
  videoResolution: 'small',
  artistName: '',
  title: '',
  title2: '',
  internalRef: '',
  copyrightNotice: '',
  senderName: '',
  senderEmail: '',
  senderAdditionalEmail: '',
  labelId0: 0,
  labelId1: 0,
  labelId2: 0,
  labelName: '',
  senderLabel: '',
  releaseDate: '',
  impactDate: '',
  dispatchDate: '',
  playsNumber: 0,
  downloadAuthorised: 0,
  expiryDate: '',
  individualExpiryDate: 0,
  watermarkTracks: 0,
  isWatermarkVideo: 0,
  directAccessWatermark: 0,
  hideSender: 0
};

var ProjectInfo = (_dec = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        _ref$params = _ref.params,
        projectId = _ref$params.projectId,
        type = _ref$params.type;
    var isLoadProjectTime = projectActions.isLoadProjectTime,
        loadProject = projectActions.loadProject,
        initProject = projectActions.initProject;

    var id = Number(projectId);

    // at first, get projectId for new SS to have ability to add recipients
    if (!id) {
      dispatch(initProject());
      var method = type === _projects2.projectTypes.sharespace ? 'ssCreate' : 'projectCreate';
      return (0, _asyncPromise2.default)(dispatch(projectActions[method]()).promise.then(function (resp) {
        return dispatch((0, _reactRouterRedux.push)('/projects/' + type + '/' + resp.data.projectId));
      }));
    }

    var promises = [];
    var isCommonLoaded = getState().project.commonLoaded;
    var commonDataPromise = void 0;

    if (!isCommonLoaded) {
      commonDataPromise = dispatch(projectActions.loadCommon()).promise;
      promises.push(commonDataPromise);
    }

    var initFormData = function initFormData() {
      var commonData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getState().project.commonData;

      var commonDataDefaults = {};
      (0, _entries2.default)(commonData.defaults).map(function (_ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            fieldName = _ref3[0],
            field = _ref3[1];

        commonDataDefaults[fieldName] = field.value;
      });
      //TODO: fix API
      if (type === _projects2.projectTypes.sharespace) {
        commonDataDefaults.downloadAuthorised = false;
      }
      var projectData = (0, _projects.getProjectData)(getState());
      var formData = (0, _extends3.default)({}, projectInfoFormDefaults, commonDataDefaults, { type: type }, projectData);
      /*if (id && !formData.senderLabel) {
        formData.senderLabel = formData.labelName;
      }*/
      dispatch((0, _reduxForm.initialize)('projectInfoForm', formData));
    };

    var initForm = function initForm() {
      if (commonDataPromise) {
        commonDataPromise.then(function (resp) {
          return initFormData(resp.data);
        });
      } else {
        initFormData();
      }
    };

    if (id) {
      if (isLoadProjectTime(id, getState())) {
        promises.push(dispatch(loadProject(id)).promise.then(initForm));
        promises.push(dispatch(statisticsActions.loadProjectStatsViewers({ projectId: id })).promise);
      } else {
        initForm();
      }
    } else {
      promises.push(dispatch(initProject()));
      initForm();
    }

    return (0, _asyncPromise2.default)(_promise2.default.all(promises));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    // initialValues: state.project.projectData,
    commonData: state.project.commonData,
    permissions: (0, _auth.getPermissions)(state),
    projectData: (0, _projects.getProjectData)(state),
    projectId: Number(ownProps.params.projectId),
    projectType: ownProps.params.type,
    projectLoading: state.project.projectLoading,
    senderEmailValue: formSelector(state, 'senderEmail'),
    senderNameValue: formSelector(state, 'senderName')
  };
}, (0, _extends3.default)({}, projectActions, statisticsActions, { changeFieldValue: _reduxForm.change, pushState: _reactRouterRedux.push })), _dec3 = (0, _reduxForm.reduxForm)({
  form: 'projectInfoForm',
  propNamespace: 'projectInfoForm',
  initialValues: projectInfoFormDefaults,
  validate: _ProjectInfoFormValidation2.default
}), _dec4 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = (0, _reactCookie.withCookies)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(ProjectInfo, _Component);

  function ProjectInfo(props) {
    (0, _classCallCheck3.default)(this, ProjectInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProjectInfo.__proto__ || (0, _getPrototypeOf2.default)(ProjectInfo)).call(this, props));

    _this.cookies = new _storage2.default(props.cookies);
    _this.state = {
      timezone: '',
      hideOptionalSection: !!_this.props.projectId && !_this.cookies.getAsBoolean({ name: 'showOptionalSection' })
    };
    return _this;
  }

  (0, _createClass3.default)(ProjectInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      (0, _get5.default)(ProjectInfo.prototype.__proto__ || (0, _getPrototypeOf2.default)(ProjectInfo.prototype), 'componentDidMount', this).call(this, function () {
        // get timezone on clientside only
        _this2.getTimezone();
      });
    }
  }, {
    key: 'onSenderAdd',
    value: function onSenderAdd(data) {
      this.setSender({
        senderEmail: data.email,
        senderName: (0, _strings.concat)(' ', data.name, data.surname)
      });

      var projectId = this.props.projectId;

      this.props.loadProjectStatsViewers({ projectId: projectId });
    }
  }, {
    key: 'onSenderDelete',
    value: function onSenderDelete() {
      this.setSender({ senderEmail: '', senderName: '' });
    }
  }, {
    key: 'getTimezone',
    value: function getTimezone() {
      this.setState({ timezone: new Date().toLocaleString('en', { timeZoneName: 'short' }).split(' ').pop() });
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      var _props = this.props,
          t = _props.t,
          projectId = _props.projectId,
          projectType = _props.projectType,
          projectData = _props.projectData;

      var title = void 0;
      if (projectType === _projects2.projectTypes.sharespace) {
        title = projectData.artistName ? t('Edit Sharespace') : t('Create Sharespace');
      } else {
        var _titles;

        var titles = (_titles = {}, (0, _defineProperty3.default)(_titles, _projects2.projectTypes.audio, projectId ? t('Edit Audio Project') : t('Create Audio Project')), (0, _defineProperty3.default)(_titles, _projects2.projectTypes.video, projectId ? t('Edit Video Project') : t('Create Video Project')), (0, _defineProperty3.default)(_titles, _projects2.projectTypes.newsletter, projectId ? t('Edit Newsletter') : t('Create Newsletter')), _titles);
        var defaultTitle = projectId ? t('Edit Project') : t('Create new Project');
        title = titles[projectType] || defaultTitle;
      }

      return title;
    }
  }, {
    key: 'setSender',
    value: function setSender(_ref4) {
      var senderEmail = _ref4.senderEmail,
          senderName = _ref4.senderName;
      var change = this.props.projectInfoForm.change;

      change('senderEmail', senderEmail);
      change('senderName', senderName);
    }
  }, {
    key: 'submit',
    value: function submit(formData) {
      var _props2 = this.props,
          projectId = _props2.projectId,
          projectType = _props2.projectType,
          pushState = _props2.pushState,
          saveProject = _props2.saveProject;

      var data = (0, _forms.normalizeFormData)(formData, { dateTimeFields: ['dispatchDate'] });
      data.daySavingLight = (0, _datetime.isDaySavingLight)();
      data.timeDifference = (0, _datetime.getTimeDifference)();
      data.projectType = projectType === _projects2.projectTypes.sharespace ? 'root_project' : 'project';
      data.contentType = projectType === _projects2.projectTypes.sharespace ? _projects2.projectTypes.audio : projectType;
      data.projectId = projectId;
      data.bcove = data.bcove || 0;
      if (projectType === _projects2.projectTypes.sharespace && !projectId) {
        data.dispatchDate = 0;
      }
      if (!projectId) {
        data.senderLabel = data.senderLabel || data.labelName;
      }
      return saveProject(data).promise.then(function (resp) {
        return pushState('/projects/' + projectType + '/' + (projectId || (0, _get7.default)(resp, 'data.id', 0)) + '/materials');
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'fillNotice',
    value: function fillNotice(e) {
      var copyrights = this.props.commonData.copyrights;

      var newCopyrightNotice = (0, _get7.default)(copyrights, [e.target.value, 'text'], '');
      this.props.changeFieldValue('projectInfoForm', 'copyrightNotice', newCopyrightNotice);
    }
  }, {
    key: 'toggleOptionalSection',
    value: function toggleOptionalSection() {
      var hideOptionalSection = !this.state.hideOptionalSection;
      this.setState({ hideOptionalSection: hideOptionalSection });
      this.cookies.setAsBoolean({ name: 'showOptionalSection', value: !hideOptionalSection });
    }
  }, {
    key: 'renderLabelField',
    value: function renderLabelField(name) {
      var _props3 = this.props,
          t = _props3.t,
          subLabels = _props3.commonData.subLabels;


      return _react2.default.createElement(
        _reduxForm.Field,
        { name: name, type: 'select', component: 'select' },
        _react2.default.createElement(
          'option',
          { value: 0 },
          t('none')
        ),
        subLabels && subLabels.map(function (subLabel) {
          return _react2.default.createElement(
            'option',
            { key: subLabel.id, value: subLabel.id },
            subLabel.subLabelName
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props4 = this.props,
          projectLoading = _props4.projectLoading,
          t = _props4.t,
          projectId = _props4.projectId,
          projectType = _props4.projectType,
          projectData = _props4.projectData,
          permissions = _props4.permissions,
          _props4$projectInfoFo = _props4.projectInfoForm,
          handleSubmit = _props4$projectInfoFo.handleSubmit,
          submitting = _props4$projectInfoFo.submitting,
          copyrights = _props4.commonData.copyrights,
          senderEmailValue = _props4.senderEmailValue,
          senderNameValue = _props4.senderNameValue;
      var hideOptionalSection = this.state.hideOptionalSection;

      var title = this.getTitle();
      var isLocked = !!projectData.isLocked;

      return _react2.default.createElement(
        'form',
        { onSubmit: handleSubmit(this.submit), className: 'page' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Project' }),
        !projectId && projectType === _projects2.projectTypes.sharespace && _react2.default.createElement(_components.Loader, { mask: true }),
        _react2.default.createElement(
          'div',
          { className: (0, _classnames2.default)('container-fluid', styles.pageContainer) },
          _react2.default.createElement(
            'h1',
            null,
            title,
            projectLoading && _react2.default.createElement(_components.Loader, { small: true, inline: true, right: true })
          ),
          _react2.default.createElement(_components.ProjectBreadcrumbs, {
            projectId: projectId,
            projectType: projectType,
            activeSection: 'info',
            notClickable: projectData.status === _projects2.projectStatus.draft
          }),
          _react2.default.createElement(
            'div',
            { className: 'hint' },
            t('Enter all the details of your project - you will then be prompted to add content and a list of recipients.')
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Project information')
            ),
            _react2.default.createElement(
              _FormRow2.default,
              { title: projectType === _projects2.projectTypes.video ? t('Director Name') : t('Artist Name'), isRequired: true },
              _react2.default.createElement(_reduxForm.Field, { name: 'artistName', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput, required: true, disabled: isLocked })
            ),
            _react2.default.createElement(
              _FormRow2.default,
              { title: t('Title'), isRequired: true },
              _react2.default.createElement(_reduxForm.Field, { name: 'title', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput, required: true, disabled: isLocked })
            ),
            _react2.default.createElement(
              _FormRow2.default,
              { title: t('Title') + ' 2' },
              _react2.default.createElement(_reduxForm.Field, { name: 'title2', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
            ),
            projectType === _projects2.projectTypes.video && _react2.default.createElement(
              _FormRow2.default,
              { title: t('Storyboard') },
              _react2.default.createElement(_reduxForm.Field, { name: 'storyboard', noIndent: true, type: 'textarea', rows: '3', component: _formComponents.formSimpleTextInput })
            ),
            projectType === _projects2.projectTypes.video && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                null,
                t('Brightcove content access (optional)')
              ),
              _react2.default.createElement(
                'p',
                { className: 'hint small' },
                t('For non watermarked project only, you can point your recipients directly to the Brightcove content by using the link below.')
              ),
              _react2.default.createElement(
                _FormRow2.default,
                { title: t('Link to content') },
                _react2.default.createElement(_reduxForm.Field, { name: 'bcove', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
              )
            ),
            projectType === _projects2.projectTypes.sharespace && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h3',
                null,
                t('Team members')
              ),
              _react2.default.createElement(_components.SSTeamMembers, { projectId: projectId })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'div',
              { onClick: this.toggleOptionalSection, className: (0, _classnames2.default)('table', styles.sectionToggle, styles.withToggleHint) },
              _react2.default.createElement(
                'h3',
                { className: 'table-cell' },
                t('Label / Sender settings')
              ),
              _react2.default.createElement(
                'div',
                { className: 'table-cell width-perc-1 text-center' },
                _react2.default.createElement('i', { className: (0, _classnames2.default)('colorPrimary', hideOptionalSection ? 'icon-chevron-bold-down' : 'icon-chevron-bold-up') }),
                _react2.default.createElement(
                  'span',
                  { className: styles.toggleHint },
                  hideOptionalSection ? t('Click Arrow to Reveal') : t('Click Arrow to Hide')
                )
              )
            ),
            _react2.default.createElement(
              _Collapse2.default,
              { 'in': !hideOptionalSection },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  t('Advanced information')
                ),
                _react2.default.createElement(
                  _FormRow2.default,
                  { title: t('Internal Ref'), hint: t('Will not be shown to recipient') },
                  _react2.default.createElement(_reduxForm.Field, { name: 'internalRef', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'formRow' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      null,
                      t('Copyright Notice')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.copyrights },
                      _react2.default.createElement(
                        'select',
                        { onChange: function onChange(e) {
                            return _this3.fillNotice(e);
                          } },
                        _react2.default.createElement(
                          'option',
                          { value: -1 },
                          t('Select')
                        ),
                        copyrights && copyrights.map(function (copyright, index) {
                          return _react2.default.createElement(
                            'option',
                            { key: copyright.id, value: index },
                            copyright.header
                          );
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reduxForm.Field, { name: 'copyrightNotice', noIndent: true, type: 'textarea', rows: '3', component: _formComponents.formSimpleTextInput })
                  )
                ),
                projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h4',
                    null,
                    t('Sender settings')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'hint small' },
                    t('Use these fields to override your accounts default settings.')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'hint small' },
                    t('This will enable you to display a different senders name on the player & emails.')
                  ),
                  senderEmailValue ? _react2.default.createElement(_ProjectSenderInfo2.default, {
                    projectId: projectId,
                    onDelete: this.onSenderDelete,
                    senderEmail: senderEmailValue,
                    senderName: senderNameValue
                  }) : _react2.default.createElement(
                    _FormRow2.default,
                    { title: t('Enter sender email here') },
                    _react2.default.createElement(_AddSenderField2.default, {
                      projectId: projectId,
                      hideGroups: true,
                      onAdd: this.onSenderAdd,
                      withZIndex: false
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_formComponents.CheckboxField, {
                      name: 'hideSender',
                      type: 'checkbox',
                      textAfter: t('Hide sender information on emails. Emails will be sent on behalf of your label.')
                    })
                  ),
                  _react2.default.createElement(
                    'h4',
                    { className: 'margin-top-20' },
                    t('Statistics and Feedback')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'hint small' },
                    t('Use this field to add people you want to share statistics with'),
                    '.'
                  ),
                  _react2.default.createElement(
                    _FormRow2.default,
                    { title: t('Enter their email here') },
                    _react2.default.createElement(_AddStatsViewerField2.default, {
                      projectId: projectId,
                      hideGroups: true,
                      withZIndex: false
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(_ProjectStatsViewersList2.default, {
                      projectId: projectId,
                      className: (0, _classnames2.default)('margin-bottom-20', styles.listRow)
                    })
                  )
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  t('Label')
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'hint small' },
                  t('Labels logos will appear on emails and player'),
                  '.'
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  t('Option 1. Use existing Label')
                ),
                _react2.default.createElement(
                  _FormRow2.default,
                  { title: t('Label 1') },
                  this.renderLabelField('labelId0')
                ),
                _react2.default.createElement(
                  _FormRow2.default,
                  { title: t('Label 2') },
                  this.renderLabelField('labelId1')
                ),
                _react2.default.createElement(
                  _FormRow2.default,
                  { title: t('Label 3') },
                  this.renderLabelField('labelId2')
                ),
                _react2.default.createElement(
                  'h5',
                  null,
                  t('Option 2. Enter a different Label / Agency name')
                ),
                _react2.default.createElement(
                  _FormRow2.default,
                  { title: t('Label name') },
                  _react2.default.createElement(_reduxForm.Field, { name: projectId ? 'senderLabel' : 'labelName', noIndent: true, type: 'text', component: _formComponents.formSimpleTextInput })
                ),
                _react2.default.createElement(
                  'h4',
                  null,
                  t('Key Dates')
                ),
                _react2.default.createElement(
                  _FormRow2.default,
                  { title: t('Release date') },
                  _react2.default.createElement(_reduxForm.Field, { name: 'releaseDate', component: _formComponents.formDate, allowPast: true }),
                  _react2.default.createElement(
                    'div',
                    { className: 'hint small' },
                    t('Official release date. This will appear on the player and email notification.')
                  )
                ),
                _react2.default.createElement(
                  _FormRow2.default,
                  { title: t('Impact date') },
                  _react2.default.createElement(_reduxForm.Field, { name: 'impactDate', component: _formComponents.formDate, allowPast: true }),
                  _react2.default.createElement(
                    'div',
                    { className: 'hint small' },
                    t('Official impact date. Will appear on the email notification only.')
                  )
                ),
                projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
                  _FormRow2.default,
                  { title: t('Dispatch date') },
                  _react2.default.createElement(_reduxForm.Field, { name: 'dispatchDate', component: _formComponents.formDatetime }),
                  _react2.default.createElement(
                    'div',
                    { className: 'hint small' },
                    _react2.default.createElement(
                      'div',
                      null,
                      t('IMPORTANT! Your project will be sent immediately unless you specify a dispatch date & time.')
                    ),
                    _react2.default.createElement(_reactI18next.Interpolate, { i18nKey: 'Your time zone: {{timezone}}', timezone: this.state.timezone })
                  )
                ),
                projectType === _projects2.projectTypes.video && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'h4',
                    null,
                    t('Video resolution for your recipients')
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reduxForm.Field, { name: 'videoResolution', component: _formComponents.formRadio, type: 'radio', value: 'small', textAfter: t('Small (eg. 480 x 270)') })
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reduxForm.Field, { name: 'videoResolution', component: _formComponents.formRadio, type: 'radio', value: 'medium', textAfter: t('Standard (eg. 640x360)') })
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_reduxForm.Field, { name: 'videoResolution', component: _formComponents.formRadio, type: 'radio', value: 'hd', textAfter: t('High Definition (eg. 1280x720)') })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
              'h3',
              null,
              t('Security')
            ),
            projectType !== _projects2.projectTypes.video && _react2.default.createElement(
              'div',
              { className: 'margin-vert-10' },
              _react2.default.createElement(_formComponents.CheckboxField, {
                name: 'watermarkTracks',
                type: 'checkbox',
                textAfter: t('Watermark all tracks'),
                disabled: isLocked || !permissions.setWatermark
              })
            ),
            projectType === _projects2.projectTypes.video && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'margin-vert-10' },
                _react2.default.createElement(_formComponents.CheckboxField, { name: 'isWatermarkVideo', type: 'checkbox', textAfter: t('Watermark video stream'), disabled: !permissions.setWatermark }),
                _react2.default.createElement(
                  'div',
                  { className: 'hint small' },
                  t('Watermarking enables you to trace your content.')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'margin-vert-10' },
                _react2.default.createElement(_formComponents.CheckboxField, { name: 'watermarkTracks', type: 'checkbox', textAfter: t('Watermark audio stream'), disabled: !permissions.setWatermark }),
                _react2.default.createElement(
                  'div',
                  { className: 'hint small' },
                  t('This feature is aimed at Music Video. Watermarking Audio enables you to trace the audio part of the video.')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'formRow' },
              _react2.default.createElement(
                'div',
                null,
                t('Number of plays')
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _reduxForm.Field,
                  { name: 'playsNumber', type: 'select', component: 'select' },
                  _react2.default.createElement(
                    'option',
                    { value: 0 },
                    t('Unlimited')
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 1 },
                    t('1 play')
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 3 },
                    t('3 plays')
                  ),
                  _react2.default.createElement(
                    'option',
                    { value: 5 },
                    t('5 plays')
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'hint small' },
                  t('Set the number of plays per content')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'margin-vert-10' },
              _react2.default.createElement(_formComponents.CheckboxField, { name: 'downloadAuthorised', type: 'checkbox', textAfter: t('Download album authorised'), disabled: isLocked }),
              _react2.default.createElement(
                'div',
                { className: 'hint small' },
                t('This will allow you to grant individual recipients with download rights. Option not available for video projects.')
              )
            ),
            projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
              _FormRow2.default,
              { title: t('Project expiration date') + '*' },
              _react2.default.createElement(_reduxForm.Field, { name: 'expiryDate', component: _formComponents.formDate, required: true }),
              _react2.default.createElement(
                'div',
                { className: 'hint small' },
                t('Your project will expire at 23h59 on the above date')
              )
            ),
            projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
              'div',
              { className: 'margin-vert-10' },
              _react2.default.createElement(_formComponents.CheckboxField, { name: 'individualExpiryDate', type: 'checkbox', textAfter: t('Individual expire dates') }),
              _react2.default.createElement(
                'div',
                { className: 'hint error small' },
                t('Set expiry date individually for each recipient')
              )
            ),
            projectType !== _projects2.projectTypes.sharespace && _react2.default.createElement(
              'div',
              { className: 'margin-vert-10' },
              _react2.default.createElement(_formComponents.CheckboxField, { name: 'directAccessWatermark', type: 'checkbox', textAfter: t('No Password'), disabled: !permissions.noPasswordFeature }),
              _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)('hint error small', { disabled: !permissions.noPasswordFeature }) },
                t('WARNING - The recipient will NOT be required to enter a password.')
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-right margin-vert-40' },
            _react2.default.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary wide pos-rel', disabled: submitting },
              t('Next'),
              submitting && _react2.default.createElement(_components.Loader, { mask: true })
            )
          )
        )
      );
    }
  }]);
  return ProjectInfo;
}(_ClientSideComponent2.default), _class3.propTypes = {
  changeFieldValue: _propTypes2.default.func.isRequired,
  commonData: _propTypes2.default.object,
  cookies: _propTypes2.default.object,
  loadProjectStatsViewers: _propTypes2.default.func,
  permissions: _propTypes2.default.object,
  projectData: _propTypes2.default.object,
  projectId: _propTypes2.default.number,
  projectInfoForm: _propTypes2.default.object,
  projectLoading: _propTypes2.default.bool,
  projectType: _propTypes2.default.string,
  pushState: _propTypes2.default.func.isRequired,
  saveProject: _propTypes2.default.func.isRequired,
  senderEmailValue: _propTypes2.default.string,
  senderNameValue: _propTypes2.default.string,
  t: _propTypes2.default.func.isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'onSenderAdd', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSenderAdd'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'onSenderDelete', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'onSenderDelete'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleOptionalSection', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleOptionalSection'), _class2.prototype)), _class2)) || _class) || _class) || _class) || _class) || _class);
exports.default = ProjectInfo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Project/ProjectInfo/ProjectInfo.js
// module id = 2194
// module chunks = 1